
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SendCampaignGrid extends Serenity.EntityGrid<SendCampaignRow, any> {
        protected getColumnsKey() { return 'Administration.SendCampaign'; }
        protected getDialogType() { return SendCampaignDialog; }
        protected getIdProperty() { return SendCampaignRow.idProperty; }
        protected getInsertPermission() { return SendCampaignRow.insertPermission; }
        protected getLocalTextPrefix() { return SendCampaignRow.localTextPrefix; }
        protected getService() { return SendCampaignService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}